export default "/static/assets/1d0bb6cbbc028f58.png"